import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Constants } from '../app.constant';
import * as _ from 'lodash';
import { EncryptionService } from 'app/services/encryption.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,private encryptionService:EncryptionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.encryptionService.getData('currentUser') && localStorage.getItem('authorizedRole')) {
			return true;
		}
		this.router.navigate(['/login'], { queryParams: { url: state.url }});
		return false;
  }
}

@Injectable()
export class AuthGuardForChildRoutes implements CanActivate {

  constructor(private router: Router,private encryptionService:EncryptionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
	if(route.queryParams.switchtoadmin == "yes")
	{
		Constants.resetCostomerForPanasonicAdmin(null);
	}	
	
	if (this.encryptionService.getData('currentUser') && localStorage.getItem('authorizedRole') && Constants.ScoopUserRoleInformations("isPanasonicRole") && Constants.CurrentCustomerInfomations("customerId") == null) {
			return true;
		}
		this.router.navigate(['/no-permission']);
		return false;
  }
}

@Injectable()
export class AuthGuardForCommonModules implements CanActivate {

  constructor(private router: Router, private encryptionService:EncryptionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		let action = Constants.ScopeResouceActions(route.data.resource);		
		if(this.encryptionService.getData('currentUser') && localStorage.getItem('authorizedRole')){
			if(_.includes(action,  route.data.resourceAction[0])){
				return true;
			}
			// return true;
		}
		this.router.navigate(['/no-permission']);
		return false;
  }
}

@Injectable()
export class AuthGuardForChildRouteAddEdit implements CanActivate {
	constructor(private router: Router,private encryptionService:EncryptionService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
	  let action = Constants.ScopeResouceActions(route.data.resource);		
		if(this.encryptionService.getData('currentUser')  && localStorage.getItem('authorizedRole') && Constants.CurrentCustomerInfomations("customerId") != null){
			if(_.includes(action,  route.data.resourceAction[0])){
				return true;
			}
		}
		this.router.navigate(['/no-permission']);
		return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts